import { render, staticRenderFns } from "./AccessLog.vue?vue&type=template&id=b2c57142&"
import script from "./AccessLog.vue?vue&type=script&lang=ts&"
export * from "./AccessLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports